export const isContentEmpty = (html: string): boolean => {
  if (!html) return true;
  const div = document.createElement('div');
  div.innerHTML = html;
  const text = div.textContent?.trim() || '';
  return text.length === 0;
};

// Для отправки на бэк
export const getContentForBackend = (html: string): string  => {
  return isContentEmpty(html) ? "" : html;
};